import {RECEIVE_SHIPMENT_DETAILS_DATA} from "../actions/shipmentDetailsDataActions";

const initialState = {
  item: {}
};

export default function (state = initialState, action) {

  switch (action.type) {
    case RECEIVE_SHIPMENT_DETAILS_DATA:
      return {
        ...state,
        item: action.payload
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/shipmentDetailsReducer.js